var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 28,
    viewBox: "0 0 222 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 27.8943H15.1836V16.533H15.5938V27.8943ZM3.89844 27.4939H3.48828V22.1589H3.89844V27.4939ZM6.1543 27.4939H5.74414V20.5173H6.1543V27.4939ZM1.64062 27.2888H1.23047V23.5955H1.64062V27.2888ZM8.41211 27.2888H8.00195V19.0818H8.41211V27.2888ZM10.6699 27.0828H10.2598V18.2605H10.6699V27.0828ZM12.9258 27.0828H12.5156V15.7986H12.9258V27.0828Z",
    fill: "url(#paint0_linear_30_2241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7197 8.82251H32.125V30.5715H31.7148V15.4045L31.3096 15.5647V5.33423H31.7197V8.82251ZM36.2334 11.0793H36.6387V29.5461L36.2285 29.5452V14.7209L35.8232 14.552V2.76978H36.2334V11.0793ZM33.9766 9.84888H34.3809V29.5452H33.9707V14.5149L33.5664 14.675V4.10278H33.9766V9.84888ZM38.4902 11.9006H38.8945V28.9299H38.4844V28.5188H38.0801V27.2883H38.4844V15.6653L38.0801 15.4963V1.53833H38.4902V11.9006ZM22.6914 27.2883H22.2812V28.6995L21.8721 28.7297V22.1936L22.2812 22.1633V10.3606H22.6914V27.2883ZM18.1777 28.5188H17.7676V28.2971H17.3574V19.0471H17.7676V12.926H18.1777V28.5188ZM20.4404 28.4622H20.0303V28.2971H19.625V20.4553H20.0303V11.592H20.4404V28.4622ZM24.9482 27.2883H24.5381V9.13013H24.9482V27.2883ZM27.2061 17.1838L26.7949 17.3459V7.89868H27.2061V17.1838ZM29.5801 16.2473L29.1699 16.4094V6.5647H29.5801V16.2473Z",
    fill: "url(#paint1_linear_30_2241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0107 30.572H49.292V16.825H50.0107V30.572ZM52.3857 30.572H51.667V18.0564H52.3857V30.572ZM45.6123 29.5457H44.8936V14.7732H45.6123V29.5457ZM47.8701 29.5457H47.1514V15.7986H47.8701V29.5457ZM43.5615 28.9304H42.8428V13.9529H43.5615V28.9304ZM41.2529 12.9265V28.7244H40.5352V12.9265H41.2529Z",
    fill: "url(#paint2_linear_30_2241)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.507 3.73511L222.001 23.553H218.915L216.622 18.2022C211.78 18.457 207.675 20.4104 203.91 23.553H203.174L211.667 3.73511H213.507ZM204.193 22.5904C207.902 19.646 211.384 18.1172 216.395 17.6359L211.356 5.88676L204.193 22.5904Z",
    fill: "#00443F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.169 3.73511V4.30133H199.507V23.553H196.676V4.30133H191.297V3.73511H205.169Z",
    fill: "#00443F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.037 13.5874C191.972 15.9939 192.595 19.0515 191.095 21.3164C191.095 21.3164 189.821 23.553 185.291 23.553C180.534 23.553 178.015 21.7694 178.015 21.7694L179.487 20.2972C180.534 21.8826 182.346 22.9868 185.291 22.9868C189.736 22.9868 190.33 18.5702 186.904 16.277L182.035 13.3326C179.26 11.6056 176.599 9.11424 178.864 5.88676C178.864 5.88676 180.28 3.73511 184.356 3.73511C188.603 3.73511 190.189 5.03742 190.189 5.03742L188.971 6.25481C188.235 5.09405 187.018 4.30133 184.356 4.30133C181.186 4.30133 178.807 7.89686 183.224 10.5864L188.037 13.5874Z",
    fill: "#00443F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.883 3.73511H175.714V23.553H172.883V3.73511Z",
    fill: "#00443F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.005 3.73511H170.628L162.134 23.553H160.294L151.801 3.73511H154.887L162.446 21.4013L170.005 3.73511Z",
    fill: "#00443F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.355 22.9868H146.263V23.553H133.523V3.73511H136.355V22.9868Z",
    fill: "#00443F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.773 3.73511L131.266 23.553H128.181L125.887 18.2022C121.046 18.457 116.941 20.4104 113.176 23.553H112.439L120.933 3.73511H122.773ZM113.459 22.5904C117.167 19.646 120.65 18.1172 125.661 17.6359L120.621 5.88676L113.459 22.5904Z",
    fill: "#00443F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.196 3.73511H115.847L109.845 13.3326V23.553H107.014V14.097L99.625 3.73511H103.107L109.534 12.7664L115.196 3.73511Z",
    fill: "#00443F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5908 4.38507C99.4887 6.28192 102.207 12.199 100.281 17.2101C98.3562 22.1645 92.4958 24.8258 87.4564 22.9006C82.502 20.9755 79.8407 15.115 81.7659 10.0756C83.6344 5.29103 89.3816 2.40328 94.5908 4.38507ZM87.6546 22.3627C91.3067 23.7783 95.7799 21.0038 97.6202 16.1909C99.4887 11.3779 98.0165 6.33854 94.3927 4.92298C90.7405 3.50742 86.2673 6.28192 84.4271 11.0948C82.5586 15.9077 84.0308 20.9471 87.6546 22.3627Z",
    fill: "#00443F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5848 23.553C76.1602 21.5995 75.0277 19.9574 73.1025 19.1647C71.0924 18.2871 68.9691 18.1738 66.8175 18.1738V23.553H63.9863V3.73511C66.7891 3.73511 69.6203 3.73511 72.4231 3.73511C74.7729 3.73511 76.9812 4.86756 78.3118 6.79272C79.784 8.97269 79.9539 11.8604 78.7082 14.1536C77.4908 16.4469 75.056 17.8907 72.4797 17.8907C75.9054 17.8907 78.7648 20.3255 79.416 23.553H76.5848ZM66.8175 17.6076C69.6769 17.6076 71.4039 17.4377 72.961 16.8149C74.9711 16.0222 76.2451 14.1253 76.6131 12.0303C76.9812 9.93527 76.3867 7.27401 74.6597 5.91507C73.329 4.83925 71.4888 4.49951 69.8468 4.35796C68.8275 4.27302 67.8367 4.30133 66.8175 4.30133V17.6076Z",
    fill: "#00443F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_2241",
    x1: 13.0179,
    y1: 20.6035,
    x2: 13.0179,
    y2: 27.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCA08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#BCA08A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_2241",
    x1: -4006.5,
    y1: 12.396,
    x2: -4006.5,
    y2: 28.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307692,
    stopColor: "#BCA08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860577,
    stopColor: "#BCA08A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_2241",
    x1: -3863.23,
    y1: 11.8869,
    x2: -3863.23,
    y2: 28.7252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BCA08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899038,
    stopColor: "#BCA08A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.1665,
    height: 27.2884,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/DarkLogo.46d0be8c4722cb48d86f1773cdca5a11.svg";
export { ForwardRef as ReactComponent };